import React from 'react';
import { EmptyStateVerticalTemplate } from 'themes/components';

function EmptyStateVertical(props) {
    return <EmptyStateVerticalTemplate {...props} />
}

export default EmptyStateVertical;